/*
 * Desktop product gallery: show the chosen colour's photo.
 *
 * On desktop this layout stacks every photo (it is not a slider), so when a customer picks a colour
 * the theme's "go to the variant's photo" step (updateMedia in assets/variants.js) has nothing to
 * move and the photo at the top stays the same; the colour's photo may be the last in the stack.
 * Like Shopify's own themes, this moves the chosen variant's photo to the top of the stack and
 * brings it into view if the customer has scrolled past it.
 *
 * Only a change of photo moves anything (picking a colour); picking a size of the same colour does
 * not, and the page as loaded keeps the merchant's photo order. On phones the gallery is a slider and
 * the theme already slides to the photo, so this does nothing there.
 */
(function () {
  // Per event: the theme fires its own nested change events while handling one, so a single
  // "previous photo" variable would be overwritten before the outer event is finished.
  const before = new WeakMap();

  const pickerFor = (target) => {
    const picker = target.closest && target.closest('variant-radios, variant-selects');
    if (!picker) return null;
    const view = picker.closest('.productView');
    if (!view || view.matches('.layout-4') || view.closest('.halo-popup')) return null;
    return picker;
  };
  const mediaId = (picker) => {
    const media = picker.currentVariant && picker.currentVariant.featured_media;
    return media ? media.id : null;
  };

  // Before the theme handles the change: remember the photo of the variant being left.
  document.addEventListener('change', (event) => {
    const picker = pickerFor(event.target);
    if (picker) before.set(event, mediaId(picker));
  }, true);

  // After the theme has worked out the new variant.
  document.addEventListener('change', (event) => {
    const picker = pickerFor(event.target);
    if (!picker || !before.has(event)) return;
    const after = mediaId(picker);
    if (!after || after === before.get(event)) return;

    const stack = picker.closest('.productView').querySelector('.productView-nav');
    if (!stack || stack.classList.contains('slick-initialized')) return;
    // The stacked photos carry the bare media id (only the thumbnails are prefixed with the section id,
    // which is why the theme's own step reaches the thumbnails but not these photos).
    const media = stack.querySelector(`[data-media-id="${after}"], [data-media-id="${picker.dataset.section}-${after}"]`);
    const block = media && media.closest('.productView-image');
    if (!block || block.parentElement !== stack || stack.firstElementChild === block) return;

    stack.prepend(block);

    // Scrolled down the photos: bring the top of the gallery back into view, below the header.
    const header = ['.section-header-navigation', '.announcement-bar']
      .reduce((sum, selector) => sum + (document.querySelector(selector)?.getBoundingClientRect().height || 0), 0);
    const top = block.getBoundingClientRect().top;
    if (top < header) {
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: top + window.scrollY - header - 10, behavior: smooth ? 'smooth' : 'auto' });
    }
  });
})();
